import * as React from 'react'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import Checklist from '../../../../../components/checklist'
import { Card, CardBody } from '../../../../../components/card'
import styles from './intro.module.scss'
import Button from '../../../../../components/button'

export default function Intro() {
  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <div>
            <FormattedMessage
              defaultMessage="Så här enkelt är det"
              id="landing-pages.signup.intro.heading"
              tagName="h2"
            />
            <Checklist
              className={styles.checkList}
              items={[
                <FormattedMessage
                  defaultMessage="Du laddar upp alla viktiga dokument och synkar din bank och Skatteverket"
                  id="landing-pages.signup.intro.features.upload"
                  key="1"
                />,
                <FormattedMessage
                  defaultMessage="Dooer bokar allt du skickar in samt hjälper dig så fort du har frågor"
                  id="landing-pages.signup.intro.features.questions"
                  key="2"
                />,
                <FormattedMessage
                  defaultMessage="Löner och utlägg hanterar du enkelt genom appen"
                  id="landing-pages.signup.intro.features.managing"
                  key="3"
                />,
                <FormattedMessage
                  defaultMessage="Du får full insyn i din bokföring genom våra rapporter"
                  id="landing-pages.signup.intro.features.insights"
                  key="3"
                />,
                <FormattedMessage
                  defaultMessage="Det mesta kan du sköta i farten genom vår mobilapp"
                  id="landing-pages.signup.intro.features.mobile"
                  key="4"
                />,
              ]}
              tight
            />
          </div>

          <Card className={styles.priceCard}>
            <CardBody className={styles.priceCardBody}>
              <FormattedHTMLMessage
                defaultMessage="Nytt företag och inte kommit igång?"
                id="landing-pages.signup.intro.price.heading"
                tagName="h3"
              />

              <FormattedHTMLMessage
                defaultMessage="Beställ Dooer till ditt nystartade bolag så tar vi hand om all din bokföring <strong>kostnadsfritt fram tills du börjar dra in pengar</strong>. Sedan kostar det från 895 kr/mån."
                id="landing-pages.signup.intro.price.lede"
                tagName="p"
              />
              <Button href="/signup?variant=companyRecentlyStarted" variant="success">
                <FormattedMessage
                  defaultMessage="Perfekt, jag är nystartad"
                  id="landing-pages.signup.intro.price.cta"
                />
              </Button>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  )
}
